
export default function verifyPassword() {
    return {

        passedSessionId: '',
        passedPassword: '',
       
        isPassword: true,
        errorisPassword: '',
        isVerifiedPassword: false,
        message: '',
        isSubmitting:false,
        resetData() {

            this.passedPassword = "";
            this.message = "";
            this.isPassword = true;
        },
       
        verifyPasswordData() {
            this.isSubmitting = true;
            if (this.passedPassword == "") {
                this.isPassword = false;
                this.errorisPassword = "Please enter password."
                this.message = "";
            } 
            else {
                this.isPassword = true;
                this.errorisPassword = "";
            }
            
            if (this.isPassword) {
                fetch('/api/UserAPI/VerifyPassword', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Password: this.passedPassword,
                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                    }).then(response => {

                        if (response.isSuccess) {
                            this.isVerifiedPassword = true;
                        } else {
                            this.isVerifiedPassword = false;
                            this.message = "Please enter correct password.";
                        }
                        this.isSubmitting = false;
                    });
            }

        },

        init() {

        }
    }
}